import React from 'react';
import { Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import SupplierLists from './components/SupplierLists';

const Suppliers = () => {
  const userdata = JSON.parse(localStorage.getItem('userData'));
  if (['1', '5', '6'].indexOf(userdata.type) === -1) { // not admin
    return (<Redirect to="/dashboard" />);
  }

  return (
    <Container>
      <Row>
        <SupplierLists />
      </Row>
    </Container>
  );
};

export default Suppliers;
